import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../modal/Modal";
import { Button, Checkbox, Textarea } from "@mantine/core";

type TModalProps = {
  setModalVisible: (value: boolean) => void;
  modalVisible: boolean;
  title?: string;
  successButtonName?: string;
  dangerButtonName?: string;
  onSuccess?: (acceptedDescription: string) => void;
  onDanger?: () => void;
  contentStyle?: string;
};

const AcceptAllModal: React.FC<TModalProps> = ({
  setModalVisible,
  modalVisible,
  title,
  successButtonName,
  onSuccess = () => {},
  dangerButtonName,
  onDanger,
  contentStyle,
}) => {
  const { t } = useTranslation();
  const [approved, setApproved] = React.useState<boolean>(false);

  const onModalClose = () => {
    setModalVisible(false);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    const acceptedDescription = e.target["description"].value;

    onSuccess(acceptedDescription ?? "");
  };

  return (
    <>
      <Modal compact center visible={modalVisible} onClose={onModalClose}>
        <form onSubmit={handleSubmit}>
          <div
            className={`text-center  ${contentStyle ? contentStyle : "mb-20"}`}
          >
            {title && <h2 className="f-w-700">{t(title)}</h2>}
          </div>
          <Textarea
            mt={30}
            minRows={4}
            name="description"
            placeholder={t("typeInHere")}
          ></Textarea>
          <div className="send-printdata mt-30 w-auto">
            <Checkbox
              checked={approved}
              onChange={(e: any) => setApproved(e.target.checked)}
              label={t("approveCorrectText")}
            />
            <div className="row gap-30 row-column-phone-responsive">
              <Button
                color={"green"}
                disabled={!approved}
                mt={10}
                size="lg"
                fullWidth
                type="submit"
              >
                {t(successButtonName || "confirm")}
              </Button>
              {onDanger && (
                <Button
                  className={"modal-outlined-button"}
                  color={"blue"}
                  variant={"outline"}
                  mt={10}
                  size="lg"
                  fullWidth
                  onClick={onDanger}
                >
                  {t(dangerButtonName || "cancel")}
                </Button>
              )}
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default AcceptAllModal;
